import {
  faSquareFacebook,
  faSquareInstagram,
} from '@fortawesome/free-brands-svg-icons';

export const SOCIAL_LINK = [
  {
    icon: faSquareFacebook,
    link: 'https://www.facebook.com/',
  },
  {
    icon: faSquareInstagram,
    link: 'https://www.instagram.com/',
  },
];
